import React from 'react';
import PropTypes from 'prop-types';
import { Zoom } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import LogoFlameWhite from 'modules/Common/assets/logo-flame-white.png';
import styles from './MiniLogo.styles';

const MiniLogo = ({ isSidebarOpen }) => {
  const classes = makeStyles(styles)({ isSidebarOpen });
  return (
    <Zoom timeout={750} in={!isSidebarOpen} out={isSidebarOpen}>
      <div className={classes.toolbarLogo}>
        <img src={LogoFlameWhite} className={classes.toolbarLogoImage} alt="LumiraDX" />
      </div>
    </Zoom>
  );
};

MiniLogo.propTypes = {
  isSidebarOpen: PropTypes.bool.isRequired,
};

export default MiniLogo;
